
define('app/board/views/headerView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'app/board/models/timerModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/views/timerView',
	'app/board/views/soundView',
	'app/board/views/lastPickView',
	'app/board/views/headerInfoView',
	'app/board/views/headerTeamBidView'
], function(
		$, 
		_, 
		Backbone, 
		PickSummaryCollection, 
		UserModel, 
		LeagueInstanceModel, 
		TimerModel, 
		DraftStatusModel,
		PositionColorsModel,
		TimerView,
		SoundView,
		LastPickView,
		HeaderInfoView,
		HeaderTeamBidView){
	var HeaderView = Backbone.View.extend({
		initialize: function(options) {
			this.timerModel = options.timerModel;
			this.lgInstanceModel = options.lgInstanceModel;
			this.userModel = options.userModel;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.draftStatusModel = options.draftStatusModel;
			this.prodConfig = options.prodConfig;
			this.posColors = options.posColors;
			this.pickCollection = options.pickCollection;
			
			this.soundView = new SoundView({leagueInstance: this.lgInstanceModel, draftStatusModel: this.draftStatusModel,});
			
			this.timerMobileView = new TimerView({
				el: $("#draftBoardHdrMobileInfoContainer .timerContainer"),
				draftTimer: this.timerModel,
				leagueInstance: this.lgInstanceModel,
				user: this.userModel,
				draftStatusModel: this.draftStatusModel,
				soundView: null});
			this.timerStandardView = new TimerView({
				el: $("#draftBoardHdrInfoContainer .timerContainer"),
				draftTimer: this.timerModel,
				leagueInstance: this.lgInstanceModel,
				user: this.userModel,
				draftStatusModel: this.draftStatusModel,
				soundView: this.soundView});
			
			this.lastPickMobileView = new LastPickView({
				el: $("#draftBoardHdrMobileInfoContainer").find("#draftBoardHdrLastPickContainer"),
				pickSummaryCollection: this.pickSummaryCollection,
				draftStatus: this.draftStatusModel,
				leagueInstance: this.lgInstanceModel,
				posColors: this.posColors,
				user: this.userModel});
			this.lastPickStandardView = new LastPickView({
				el: $("#draftBoardHdrInfoContainer").find(".lastPickContainer"),
				pickSummaryCollection: this.pickSummaryCollection,
				draftStatus: this.draftStatusModel,
				leagueInstance: this.lgInstanceModel,
				posColors: this.posColors,
				user: this.userModel});
			
			this.standardInfoEl = $("#draftBoardHdrInfoContainer").find(".currentPickContainer");
			this.mobileInfoEl = $("#draftBoardHdrMobileInfoContainer").find("#draftBoardHdrCurTeamContainer");
			
			this.hdrInfoMobileView = new HeaderInfoView({
				el: this.mobileInfoEl,
				pickSummaryCollection: this.pickSummaryCollection,
				draftStatus: this.draftStatusModel,
				leagueInstance: this.lgInstanceModel,
				user: this.userModel,
				prodConfig: this.prodConfig,
				pickCollection: this.pickCollection});
			this.hdrInfoStandardView = new HeaderInfoView({
				el: this.standardInfoEl,
				pickSummaryCollection: this.pickSummaryCollection,
				draftStatus: this.draftStatusModel,
				leagueInstance: this.lgInstanceModel,
				user: this.userModel,
				prodConfig: this.prodConfig,
				pickCollection: this.pickCollection});
			
			this.standardTeamBidEl = $("#draftBoardHdrInfoContainer").find(".teamBidContainer");
			this.mobileTeamBidEl = $("#draftBoardHdrMobileInfoContainer").find("#draftBoardHdrTeamBidContainer");
			
			this.headerTeamBidStandardView = new HeaderTeamBidView({
				el: this.standardTeamBidEl,
				draftStatusModel: this.draftStatusModel,
				leagueInst: this.lgInstanceModel,
				user: this.userModel});
			this.headerTeamBidMobileView = new HeaderTeamBidView({
				el: this.mobileTeamBidEl,
				draftStatusModel: this.draftStatusModel,
				leagueInst: this.lgInstanceModel,
				user: this.userModel});
			
			this.listenTo(this.lgInstanceModel, 'change:draftStatus', this.displayConfig);
			
			if(this.lgInstanceModel.get('draftType') == 'AUCTION'){
				this.listenTo(this.draftStatusModel, 'change', this.updateAuctionBidding);
			}
		},
		
		render: function () {
			this.soundView.render();
			this.timerMobileView.render();
			this.timerStandardView.render();
			this.lastPickMobileView.render();
			this.lastPickStandardView.render();
			this.hdrInfoMobileView.render();
			this.hdrInfoStandardView.render();
			this.headerTeamBidStandardView.render();
			this.headerTeamBidMobileView.render();
			
			this.updateAuctionBidding();
			this.displayConfig();
			
			return this;
		},
		
		updateAuctionBidding: function() {
			if(this.draftStatusModel.get('auctionBidding')){
				this.standardInfoEl.hide();
				this.mobileInfoEl.css({'display': 'none'});
				$("#draftBoardHdrPickPlayer").css({'display': 'none'});
				$("#draftBoardHdrShare").css({'display': 'none'});
				this.standardTeamBidEl.show();	
				this.mobileTeamBidEl.css({'display': 'inherit'});
				$("#draftBoardHdrBid").css({'display': 'inherit'});
			} else {
				this.standardTeamBidEl.hide();
				this.mobileTeamBidEl.css({'display': 'none'});
				$("#draftBoardHdrBid").css({'display': 'none'});
				this.standardInfoEl.show();
				this.mobileInfoEl.css({'display': 'inherit'});
				$("#draftBoardHdrPickPlayer").css({'display': ''});
				$("#draftBoardHdrShare").css({'display': ''});
			}
			
		},
		
		loadPlayerList: function(playerList) {
			this.lastPickMobileView.loadPlayerList(playerList);
			this.lastPickStandardView.loadPlayerList(playerList);
		},
		
		displayConfig: function() {
			switch (this.lgInstanceModel.get('draftStatus')) {
			case 'SETUP':
				$('.draftBoardHdrLoading').hide();
				$('.draftBoardHdrCompleted').hide();
				$('.draftBoardHdrPredraft').hide();
				$('.draftBoardHdrSetup').show();
				$('.draftBoardHdrActive').hide();				
				break;
			case 'PREDRAFT':
				$('.draftBoardHdrLoading').hide();
				$('.draftBoardHdrCompleted').hide();
				$('.draftBoardHdrPredraft').show();
				$('.draftBoardHdrSetup').hide();
				$('.draftBoardHdrActive').hide();
				break;
			case 'STARTED':
				$('.draftBoardHdrLoading').hide();
				$('.draftBoardHdrCompleted').hide();
				$('.draftBoardHdrPredraft').hide();
				$('.draftBoardHdrSetup').hide();
				$('.draftBoardHdrActive').show();
				break;
			case 'COMPLETED':
				$('.draftBoardHdrLoading').hide();
				$('.draftBoardHdrCompleted').show();
				$('.draftBoardHdrPredraft').hide();
				$('.draftBoardHdrSetup').hide();
				$('.draftBoardHdrActive').hide();
				break;
			default:
				break;
			}
		}
		
		
	});
	
	return HeaderView;  
});